<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M8 16a1.257 1.257 0 0 1-.567-.134L.576 12.372a1 1 0 0 1-.575-.885V4.515a1 1 0 0 1 .575-.885L7.433.136A1.246 1.246 0 0 1 8 0a1.246 1.246 0 0 1 .567.135l6.857 3.494a1.007 1.007 0 0 1 .576.885v6.972a1.007 1.007 0 0 1-.576.885l-6.857 3.494A1.257 1.257 0 0 1 8 16zm2.5-6.5v3h3v-3zm-4 0v3h3v-3zm-4 0v3h3v-3zm4-4v3h3v-3zm-4 0v3h3v-3zm4-4v3h3v-3z" fill="currentColor"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-prodoffering155',
});
</script>
